<template>
  <div
    id="sales"
    class="content"
  >
    <div id="content">
      <div class="container">
        <h1 class="page-title">
          <i class="fal fa-usd-circle"></i> Ventes
        </h1>
        <div
          class="info-button"
          @click.stop="$parent.toggleInfo"
        >
          <i class="fal fa-info-circle"></i> {{$parent.info_visible ? "Masquer les informations" : "Voir les informations"}} </div>
      </div>
      <div
        class="page-description"
        :class="{hidden: !$parent.info_visible}"
      >
        <b-message
          v-if="!isAdmin[0]"
          type="is-primary"
        >
          <i class="fal fa-info-circle"></i>
          Avant de déclarer une vente manuellement, assurez-vous que l'Objectif Quotidien actif est <strong>celui du jour</strong>.
          <br>
          Pour <strong>saisir</strong> une nouvelle vente, cliquez sur "<strong><i class="far fa-plus-circle"></i> Ajouter une Vente"</strong>, puis remplissez la totalité des champs.
          <br>
          Pour <strong>modifier</strong> l'opérateur ou la sous-campagne d'une vente, sélectionnez en un/une dans la liste déroulante.
          <br>
          Pour <strong>supprimer</strong> des ventes, cochez les lignes puis cliquez sur le bouton <strong>"Supprimer"</strong>.
          <br>
          Vous pouvez effectuer une <strong>recherche</strong> par date (jj-mm-aaaa), par heure (hh:mm), par nom ou prénom d'opérateur, ou par nom de Campagne.
        </b-message>
        <b-message
          v-if="isAdmin[0]"
          type="is-primary"
        >
          <i class="fal fa-info-circle"></i>
          Avant de déclarer une vente manuellement, assurez-vous que l'Objectif Quotidien actif est <strong>celui du jour</strong>.
          <br>
          Pour <strong>saisir</strong> une nouvelle vente, cliquez sur "<strong><i class="far fa-plus-circle"></i> Ajouter une Vente"</strong>, puis remplissez la totalité des champs.
          <br>
          Pour <strong>modifier</strong> l'opérateur ou la sous-campagne d'une vente, sélectionnez en un/une dans la liste déroulante.
          <br>
          Pour <strong>supprimer</strong> des ventes, cochez les lignes puis cliquez sur le bouton <strong>"Supprimer"</strong>.
          <br>
          Vous pouvez effectuer une <strong>recherche</strong> par date (jj-mm-aaaa), par heure (hh:mm), par nom ou prénom d'opérateur, par nom de Weezy, ou par nom de Campagne.
        </b-message>
      </div>
    </div>

    <salesTable
      @reset-filters="resetFilters"
      @add-filter="addFilter"
      @page-change="getSales"
      id="salesTable"
      ref="salesTable"
      :sales="sales"
      :users="users"
      :goals="goals"
      :weezys="weezys"
      :campaigns="campaigns"
      :checkable="true"
      :isComponentModalActive="isComponentModalActive"
      :supervisors="supervisors"
      :isAdmin="isAdmin"
      :pages_count="pages_count"
    />
  </div>

</template>

<script>
import salesTable from "@/components/salesTable";
import http from "@/modules/request";

export default {
  name: "sales",
  components: {
    salesTable
  },
  data() {
    return {
      sales: [],
      goals: [],
      users: [],
      supervisors: [],
      weezys: [],
      campaigns: [],
      saleId: "",
      goal_id: "",
      sub_campaign_id: "",
      user_id: "",
      creation_date_time: "",
      creation_date: "",
      creation_time: "",
      isComponentModalActive: false,
      isDeleteConfirmationModalActive: false,
      isAdmin: [undefined, undefined],
      pages_count: 0,
      filters: {}
    };
  },
  mounted() {
    this.getSales(1);
    this.getCampaigns();
    this.getGoals();
    this.getUsers();
    this.getWeezys();
    this.getSupervisors();
    this.isAdmin = [
      this.$store.state.role == "admin",
      this.$store.state.weezy_id
    ];
  },
  methods: {
    resetFilters() {
      this.filters = [];
    },
    addFilter(filter) {
      var tmpFilters = [];
      if (this.$refs.salesTable.filterCampaign) {
        tmpFilters.push({
          name: "campaign_id",
          value: this.$refs.salesTable.filterCampaign.id
        });
      }
      if (this.$refs.salesTable.filterWeezy) {
        tmpFilters.push({
          name: "weezy_id",
          value: this.$refs.salesTable.filterWeezy
        });
      }
      if (this.$refs.salesTable.filterSubCampaign) {
        tmpFilters.push({
          name: "sub_campaign_id",
          value: this.$refs.salesTable.filterSubCampaign
        });
      }
      if (this.$refs.salesTable.filterGoal) {
        tmpFilters.push({
          name: "goal_id",
          value: this.$refs.salesTable.filterGoal
        });
      }

      console.log(
        tmpFilters.reduce((acc, cur) => ({ ...acc, [cur.name]: cur.value }), {})
      );

      this.filters = tmpFilters.reduce(
        (acc, cur) => ({ ...acc, [cur.name]: cur.value }),
        {}
      );

      this.getSales(1);
    },
    getSales(page) {
      this.$refs.salesTable.isLoading = true;
      http
        .post("/sales-page", {
          page: page,
          per_page: parseInt(this.$refs.salesTable.perPage),
          filters: this.filters
        })
        .then(response => {
          this.sales = response.data.sales;
          this.pages_count = Math.ceil(
            response.data.total_sales / this.$refs.salesTable.perPage
          );
        })
        .catch(error => {
          console.log(error);
          this.errored = true;
          if (error.response.status === 401) {
            console.log("unauthorized, logging out ...");
          }
          return Promise.reject(error.response);
        });
    },
    getGoals() {
      http
        .get("/goals")
        .then(response => {
          this.goals = response.data;
        })
        .catch(error => {
          console.log(error);
          this.errored = true;
        });
    },
    getUsers() {
      http
        .get("/privateusers")
        .then(response => {
          this.users = response.data;
        })
        .catch(error => {
          console.log(error);
          this.errored = true;
        });
    },
    getSupervisors() {
      http
        .get("/supervisors")
        .then(response => {
          this.supervisors = response.data;
        })
        .catch(error => {
          console.log(error);
          this.errored = true;
        });
    },
    getWeezys() {
      http
        .get("/weezys")
        .then(response => {
          this.weezys = response.data;
        })
        .catch(error => {
          console.log(error);
          this.errored = true;
        });
    },
    getCampaigns() {
      http
        .get("/campaigns")
        .then(response => {
          this.campaigns = response.data;
        })
        .catch(error => {
          console.log(error);
          this.errored = true;
        });
    },
    submitAdd: function() {
      var dateTime =
        this.creation_date + " " + this.timeFormatter(this.creation_time);
      http
        .post("/sale", {
          sale: {
            goal_id: this.goal_id,
            creation_date_time: dateTime,
            user_id: this.user_id,
            weezy_id: this.weezy_id,
            sub_campaign_id: this.sub_campaign_id
          }
        })
        .then(
          function(response) {
            this.getSales(1);
            this.isComponentModalActive = false;
            this.succesToast("Vente ajoutée avec succès");
          }.bind(this)
        )
        .catch(function(error) {
          this.errorToast("Échec d'ajout de la vente");
          console.log("error (normal) :" + error);
          console.log("error (as JSON) :" + JSON.stringify(error));
        });
    },
    submitModify: function() {
      var dateTime =
        this.dateFormatter(this.creation_date_time) +
        " " +
        this.timeFormatter(this.creation_date_time);
      http
        .patch("/sales/" + this.saleId, {
          sale: {
            goal_id: this.goal_id,
            user_id: this.user_id,
            creation_date_time: dateTime,
            sub_campaign_id: this.sub_campaign_id
          }
        })
        .then(
          function(response) {
            this.succesToast("Vente(s) modifiée(s) avec succès");
            this.getSales(1);
          }.bind(this)
        )
        .catch(function(error) {
          this.errorToast("Échec de modification");
          console.log("error (normal) :" + error);
          console.log("error (as JSON) :" + JSON.stringify(error));
        });
    },
    submitDelete: function() {
      http
        .delete("/sales/" + this.saleId)
        .then(
          function(response) {
            this.succesToast("Vente(s) supprimée(s) avec succès");
            this.getSales(1);
            this.isDeleteConfirmationModalActive = false;
          }.bind(this)
        )
        .catch(function(error) {
          this.errorToast("Échec de suppression");
          console.log("error (normal) :" + error);
          console.log("error (as JSON) :" + JSON.stringify(error));
        });
    },
    clearFields: function() {
      (this.saleId = ""), (this.goal_id = ""), (this.user_id = "");
    },
    dateFormatter(value) {
      var date = new Date(value.toLocaleString());
      var years = date.getFullYear();
      var months = this.leadZero(date.getMonth() + 1);
      var days = this.leadZero(date.getDate());
      return years + "-" + months + "-" + days;
    },
    timeFormatter(value) {
      var date = new Date(value);
      var hours = this.leadZero(date.getHours());
      var minutes = this.leadZero(date.getMinutes());
      return hours + ":" + minutes;
    },
    leadZero(n) {
      return n > 9 ? n : "0" + n;
    },
    deleteCheckedRows(checkedSales) {
      var count = checkedSales.length;
      for (var i = 0; i < count; i++) {
        this.saleId = checkedSales[i].id;
        this.submitDelete();
      }
    },
    modifyRows(rows) {
      var count = rows.length;
      var modifiedArray = [];
      // From latest to oldest
      for (var i = 0; i < count; i++) {
        var modified = rows[count - i - 1];
        if (!modifiedArray.includes(modified.id)) {
          modifiedArray.push(modified.id);
          this.saleId = modified.id;
          this.goal_id = modified.goal_id;
          this.user_id = modified.user_id;
          this.creation_date_time = modified.creation_date_time;
          this.sub_campaign_id = modified.sub_campaign_id;
          this.submitModify();
        }
      }
    },
    addNewRow(rows) {
      this.user_id = rows.user_id;
      this.goal_id = rows.goal_id;
      this.sub_campaign_id = rows.sub_campaign_id;
      this.creation_date = rows.creation_date;
      this.creation_time = rows.creation_time;
      this.weezy_id = rows.weezy_id;
      this.submitAdd();
    },
    errorToast(message) {
      this.$toast.open({
        duration: 3000,
        message: message,
        position: "is-bottom",
        type: "is-danger"
      });
    },
    succesToast(message) {
      this.$toast.open({
        duration: 2000,
        message: message,
        position: "is-bottom",
        type: "is-success"
      });
    }
  }
};
</script>

<style scoped lang="less">
/* PHONE SIZE */
@media screen and (max-width: 768px) {
  #salesTable {
    margin-left: 2px;
    margin-right: 2px;
  }
}

.content {
  background-color: #ffffff;
}

.add-sale {
  width: auto;
  padding-top: 40px;
  padding-left: 30px;
}
</style>